export default __webpack_public_path__ + "static/media/shoppingCart.41c530e6.svg";